import { BaseDto } from '../../core';
import { APPROVED_STATUS } from '../../shared';
import { Product } from '..';

export class DisplayCategory extends BaseDto<DisplayCategory> {
  constructor(partial?: Partial<DisplayCategory>) {
    super(partial);
  }

  id: number;
  code: string;
  parentCode: string;
  sort: number;
  name: string;
  viName: string;
  comments: string;
  approvedStatus: APPROVED_STATUS;
  created: Date;
  parentId: number;
  products?: Product[];
}
